<template>
  <div class="bg-adatkezelesi flex overflow-auto">
    <div class="doc-width bg-white pl-45 pr-10 pt-20 pb-10 m-10">
      <h1>Adatkezelési tájékoztató</h1>
      <p class="subtitle">
        a https://gombavezetes.hu/ a weboldal látogatói és felhasználói részére
      </p>

      <h2>Bevezetés</h2>
      <p>Társaságunk az adatkezelése során alábbi alapelveket követi:</p>
      <ol class="custom-list">
        <li>
          a személyes adatokat jogszerűen és tisztességesen, valamint az Ön
          számára átláthatóan kezeljük.
        </li>
        <li>
          a személyes adatokat csak meghatározott, egyértelmű és jogszerű célból
          gyűjtjük és azokat nem kezeljük a célokkal össze nem egyeztethető
          módon.
        </li>
        <li>
          az általunk gyűjtött és kezelt személyes adatok az adatkezelés céljai
          szempontjából megfelelőek és relevánsak, valamint csak a szükségesre
          korlátozódnak.
        </li>
        <li>
          Társaságunk minden észszerű intézkedést megtesz annak érdekében, hogy
          az általunk kezelt adatok pontosak és szükség esetén naprakészek
          legyenek, a pontatlan személyes adatokat haladéktalanul töröljük vagy
          helyesbítjük.
        </li>
        <li>
          a személyes adatokat olyan formában tároljuk, hogy Ön csak a személyes
          adatok kezelése céljainak eléréséhez szükséges ideig legyen
          azonosítható.
        </li>
        <li>
          megfelelő technikai és szervezési intézkedések alkalmazásával
          biztosítjuk a személyes adatok megfelelő biztonságát az adatok
          jogosulatlan vagy jogellenes kezelésével, véletlen elvesztésével,
          megsemmisítésével vagy károsodásával szemben.
        </li>
      </ol>

      <h2>Szolgáltató, adatkezelő megnevezése:</h2>
      <table>
        <tbody>
          <tr>
            <th>Név / cégnév</th>
            <td>Gombácsi Péter Ev.</td>
          </tr>
          <tr>
            <th>Székhely:</th>
            <td>4030 Debrecen, Áchim András utca 8 A ép.</td>
          </tr>
          <tr>
            <th>Adószám:</th>
            <td>68252977-1-29</td>
          </tr>
          <tr>
            <th>Weboldal megnevezése, címe</th>
            <td>www.gombavezetes.hu</td>
          </tr>
          <tr>
            <th>Az adatkezelési tájékoztató elérhetősége</th>
            <td>www.gombavezetes.hu</td>
          </tr>
        </tbody>
      </table>

      <h3>Az adatkezelő elérhetőségei:</h3>
      <table>
        <tbody>
          <tr>
            <th>Név / cégnév</th>
            <td>Gombácsi Péter Ev.</td>
          </tr>
          <tr>
            <th>Székhely:</th>
            <td>4030 Debrecen, Áchim András utca 8 A ép.</td>
          </tr>
          <tr>
            <th>Levelezési cím</th>
            <td>4030 Debrecen, Áchim András utca 8 A ép.</td>
          </tr>
          <tr>
            <th>E-mail:</th>
            <td>gombacsi.peter@gmail.com</td>
          </tr>
          <tr>
            <th>Telefon:</th>
            <td>+36 70 670 1978</td>
          </tr>
        </tbody>
      </table>

      <h3>Tárhelyszolgáltató elérhetőségei:</h3>
      <table>
        <tbody>
          <tr>
            <th>Név / cégnév</th>
            <td>Deal-Inform Kft.</td>
          </tr>
          <tr>
            <th>Székhely:</th>
            <td>4030. Debrecen, Kosárfonó utca 28.</td>
          </tr>
          <tr>
            <th>Levelezési cím:</th>
            <td>4030. Debrecen, Kosárfonó utca 28.</td>
          </tr>
          <tr>
            <th>E-mail:</th>
            <td>kapcsolat@dealinform.hu</td>
          </tr>
        </tbody>
      </table>

      <p>
        A weboldalunk látogatóinktól csak akkor kérjük a személyes adataikat, ha
        érdeklődni szeretnénk az oldalon.
      </p>
      <p>
        Az adatkezeléssel kapcsolatos kérdéseivel Ön a
        <strong>gombacsi.peter@gmail.com</strong> e-mail, illetve postacímen
        kérhet további tájékoztatást, válaszunkat késedelem nélkül, 20 napon
        belül (legfeljebb azonban 1 hónapon belül) megküldjük Önnek az Ön által
        megadott elérhetőségre.
      </p>
      <p>
        A <strong>gombacsi.peter@gmail.com</strong>-ra megkapott adatokat
        illetéktelen személyeknek nem adjuk ki.
      </p>
      <p>
        <u>Kezelt adatok:</u> jogosítvány, lakcímkártya, személyi igazolvány,
        útlevél, diákigazolvány, orvosi papírok, telefonszám és email cím.
      </p>

      <ol class="number-list">
        <li>név</li>
        <li>születési név</li>
        <li>anyja neve</li>
        <li>születési hely és idő</li>
        <li>állampolgárság</li>
        <li>lakcím</li>
        <li>értesítési cím</li>
        <li>telefonszám</li>
        <li>e-mail cím</li>
        <li>személyazonosító okmány adatai</li>
        <li>járművezetői igazolvány adatai</li>
        <li>vezetői engedély adatai</li>
        <li>nyilatkozat alapfokú iskolai végzettségről</li>
        <li>felmentést igazoló okmány adatai</li>
        <li>egészségügyi alkalmasságának adatai</li>
        <li>járművezetéstől eltiltásának adatai</li>
        <li>okmányai visszavonásának adatai</li>
        <li>utánképzési kötelezettségére vonatkozó adatai</li>
        <li>vezetési jártasság igazolására vonatkozó adatai</li>
        <li>tanfolyammentes vizsgára kötelezésének adatai</li>
        <li>kényszergyógyítás vagy kényszergyógykezelés ténye</li>
        <li>soron kívüli egészségi alkalmassági igazolás adatai</li>
        <li>rendkívüli pályaalkalmassági vizsgálatának adatai</li>
        <li>gondviselő neve</li>
        <li>gondviselő telefonszáma</li>
        <li>gondviselő email címe</li>
      </ol>

      <h2>Társaságunk az Ön személyes adatait</h2>
      <ol class="custom-list">
        <li>
          az Ön előzetes tájékoztatáson alapuló és önkéntes hozzájárulása
          alapján és csakis a szükséges mértékben és minden esetben célhoz
          kötötten kezeljük, azaz gyűjtjük, rögzítjük, rendszerezzük, tároljuk
          és felhasználjuk.
        </li>
        <li>
          egyes esetekben az Ön adatainak kezelése jogszabályi előírásokon
          alapul és kötelező jellegű, ilyen esetekben erre a tényre külön
          felhívjuk az Ön figyelmét.
        </li>
        <li>
          illetve bizonyos esetekben az Ön személyes adatainak kezeléséhez
          Társaságunknak, vagy pedig harmadik személynek fűződik jogos érdeke,
          például honlapunk működtetése, fejlesztése és biztonsága.
        </li>
      </ol>

      <h2>Fogalommeghatározások</h2>
      <ul class="definition-list">
        <li>
          a <strong>GDPR</strong> (General Data Protection Regulation) az
          Európai Unió új Adatvédelmi Rendelete;
        </li>
        <li>
          <strong>adatkezelés:</strong> a személyes adatokon vagy
          adatállományokon automatizált vagy nem automatizált módon végzett
          bármely művelet vagy műveletek összessége, így a gyűjtés, rögzítés,
          rendszerezés, tagolás, tárolás, átalakítás vagy megváltoztatás,
          lekérdezés, betekintés, felhasználás, közlés, továbbítás, terjesztés
          vagy egyéb módon történő hozzáférhetővé tétel útján, összehangolás
          vagy összekapcsolás, korlátozás, törlés, illetve megsemmisítés;
        </li>
        <li>
          <strong>adatfeldolgozó:</strong> az a természetes vagy jogi személy,
          közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely az
          adatkezelő nevében személyes adatokat kezel;
        </li>
        <li>
          <strong>személyes adat:</strong> azonosított vagy azonosítható
          természetes személyre (érintett) vonatkozó bármely információ;
          azonosítható az a természetes személy, aki közvetlen vagy közvetett
          módon, különösen valamely azonosító, például név, szám,
          helymeghatározó adat, online azonosító vagy a természetes személy
          testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy
          szociális azonosságára vonatkozó egy vagy több tényező alapján
          azonosítható;
        </li>
        <li>
          <strong>adatkezelő:</strong> az a természetes vagy jogi személy,
          közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely a
          személyes adatok kezelésének céljait és eszközeit önállóan vagy
          másokkal együtt meghatározza; ha az adatkezelés céljait és eszközeit
          az uniós vagy a tagállami jog határozza meg, az adatkezelőt vagy az
          adatkezelő kijelölésére vonatkozó különös szempontokat az uniós vagy a
          tagállami jog is meghatározhatja;
        </li>
        <li>
          <strong>az érintett hozzájárulása:</strong> az érintett akaratának
          önkéntes, konkrét és megfelelő tájékoztatáson alapuló és egyértelmű
          kinyilvánítása, amellyel az érintett nyilatkozat vagy a megerősítést
          félreérthetetlenül kifejező cselekedet útján jelzi, hogy beleegyezését
          adja az őt érintő személyes adatok kezeléséhez;
        </li>
        <li>
          <strong>adatvédelmi incidens:</strong> a biztonság olyan sérülése,
          amely a továbbított, tárolt vagy más módon kezelt személyes adatok
          véletlen vagy jogellenes megsemmisítését, elvesztését,
          megváltoztatását, jogosulatlan közlését vagy az azokhoz való
          jogosulatlan hozzáférést eredményezi.
        </li>
        <li>
          <strong>címzett:</strong> az a természetes vagy jogi személy,
          közhatalmi szerv, ügynökség vagy bármely egyéb szerv, akivel vagy
          amellyel a személyes adatot közlik, függetlenül attól, hogy harmadik
          fél-e. Azon közhatalmi szervek, amelyek egy egyedi vizsgálat keretében
          az uniós vagy a tagállami joggal összhangban férhetnek hozzá személyes
          adatokhoz, nem minősülnek címzettnek; az említett adatok e közhatalmi
          szervek általi kezelése meg kell, hogy feleljen az adatkezelés
          céljainak megfelelően az alkalmazandó adatvédelmi szabályoknak;
        </li>
        <li>
          <strong>harmadik fél:</strong> az a természetes vagy jogi személy,
          közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely nem azonos
          az érintettel, az adatkezelővel, az adatfeldolgozóval vagy azokkal a
          személyekkel, akik az adatkezelő vagy adatfeldolgozó közvetlen
          irányítása alatt a személyes adatok kezelésére felhatalmazást kaptak.
        </li>
      </ul>

      <h2>Az adatkezelés irányelvei</h2>
      <p>
        <strong
          ><u
            >Az adatkezelő kijelenti, hogy az adatkezelési tájékoztatóban
            foglaltak szerint végzi a személyes adatok kezelését és betartja a
            vonatkozó jogszabályok előírásait, különös figyelemmel az
            alábbiakra:</u
          ></strong
        >
      </p>
      <p>
        A személyes adatok kezelését jogszerűen és tisztességesen, valamint az
        érintett számára átlátható módon kell végezni.
      </p>
      <p>
        A személyes adatok gyűjtése csak meghatározott, egyértelmű és jogszerű
        célból történhet.
      </p>
      <p>
        A személyes adatok kezelésének célja megfelelő és releváns legyen, és
        csak a szükséges mértékű lehet.
      </p>
      <p>
        A személyes adatoknak pontosnak és naprakésznek kell lenniük. A
        pontatlan személyes adatokat haladéktalanul törölni kell.
      </p>
      <p>
        A személyes adatok tárolásának olyan formában kell történnie, hogy az
        érintettek azonosítását csak szükséges ideig tegye lehetővé. A személyes
        adatok ennél hosszabb ideig történő tárolására csak akkor kerülhet sor,
        ha a tárolás közérdekű archiválás céljából, tudományos és történelmi
        kutatási célból vagy statisztikai célból történik.
      </p>
      <p>
        A személyes adatok kezelését oly módon kell végezni, hogy megfelelő
        technikai vagy szervezési intézkedések alkalmazásával biztosítva legyen
        a személyes adatok megfelelő biztonsága, az adatok jogosulatlan vagy
        jogellenes kezelésével, véletlen elvesztésével, megsemmisítésével vagy
        károsodásával szembeni védelmet is ideértve.
      </p>
      <p>
        Az adatvédelem elveit minden azonosított vagy azonosítható természetes
        személyre vonatkozó információ esetében alkalmazni kell.
      </p>

      <h2>Közösségi oldalak</h2>
      <p>
        A közösségi oldal egy médiaeszköz, ahol az üzenetet közösségi
        felhasználókon keresztül terjesztik. A közösségi média az internetet és
        az online megjelenési lehetőségeket használja annak érdekében, hogy a
        felhasználók tartalombefogadókból tartalomszerkesztővé váljanak. A
        közösségi média az internetes alkalmazások olyan felülete, amelyen a
        felhasználók által létrehozott tartalom található, Facebook, Twitter,
        Instagramm, TikTok, Youtube stb.
      </p>
      <p>
        A közösségi média megjelenési formái lehetnek nyilvános beszédek,
        előadások, bemutatók, termékek vagy szolgáltatások ismertetése. A
        közösségi médiában megjelent információk formái lehetnek fórumok,
        blogbejegyzések, kép-, videó-, és hanganyagok, üzenőfalak, e-mail
        üzenetek, stb. A fentieknek megfelelően a kezelt adatok köre a személyes
        adatokon túl lehet a felhasználó nyilvános profilképe is.
      </p>
      <p>
        Az érintettek köre: a weboldal látogatói. Az adatgyűjtés célja a
        weboldal vagy a hozzá kapcsolódó weblap népszerűsítése. Az adatkezelés
        jogalapja az érintett önkéntes hozzájárulása. Az adatkezelés időtartama:
        az adott közösségi oldalon megtekinthető szabályozás szerint. Az adatok
        törlési határideje: az adott közösségi oldalon megtekinthető szabályozás
        szerint. Az adatok megismerésére jogosultak: az adott közösségi oldalon
        megtekinthető szabályozás szerint. Az adatkezeléssel kapcsolatos jogok:
        az adott közösségi oldalon megtekinthető szabályozás szerint. Az adatok
        tárolási módja: elektronikus.
      </p>
      <p>
        Fontos figyelembe venni, hogy amikor a felhasználó feltölt vagy beküld
        valamilyen személyes adatot, világszerte érvényes engedélyt ad a
        közösségi oldal üzemeltetőjének arra, hogy az ilyen tartalmakat
        tárolhassa és felhasználhassa. Ezért nagyon fontos meggyőződni arról,
        hogy a közzétett információ közléséhez a felhasználó teljes
        jogosultsággal rendelkezik-e.
      </p>
      <p>
        <strong>Google Analytics</strong> Weboldalunk a Google Analytics
        alkalmazást nem használja. Google Analytics alkalmazása esetén
        amennyiben a fent megnevezett oldal használná:
      </p>
      <p>
        A Google Analytics belső cookie-k (sütik) alapján állít össze jelentést
        ügyfelei részére a weblap felhasználóinak szokásairól.
      </p>
      <p>
        A weboldal üzemeltetőjének megbízásából a Google az információkat arra
        használja, hogy kiértékelje, hogyan használják a felhasználók a
        honlapot. További szolgáltatásként a honlap aktivitásával összefüggő
        jelentéseket készít weboldal üzemeltetőjének részére, hogy az további
        szolgáltatásokat teljesíthessen.
      </p>
      <p>
        Az adatokat a Google szerverei kódolt formátumban tárolják, hogy
        megnehezítsék és elejét vegyék az adatokkal való visszaélésnek. A Google
        Analytics letiltása az alábbiak szerint történhet. Idézet az oldalról:
        Azok a webhelyfelhasználók, akik nem szeretnék, hogy a Google Analytics
        JavaScript jelentést készítsen az adataikról, telepíthetik a Google
        Analytics letiltó böngészőbővítményét. A bővítmény megtiltja a Google
        Analytics JavaScript (ga.js, analytics.js, és dc.js) számára, hogy
        információkat küldjön a Google Analytics rendszernek. A
        böngészőbővítmény a legtöbb újabb böngészőben használható.
      </p>
      <p>
        <strong
          >A Google Analytics letiltó böngészőbővítménye nem akadályozza meg az
          adatküldést maga a webhely és más internetes elemzési szolgáltatások
          részére.</strong
        ><br />
        <a
          href="https://support.google.com/analytics/answer/6004245?hl=hu"
          target="_blank"
          rel="noopener"
          >https://support.google.com/analytics/answer/6004245?hl=hu</a
        >
      </p>
      <p>
        <strong>A Google adatvédelmi irányelvei: </strong>
        <a
          href="https://policies.google.com/privacy?hl=hu"
          target="_blank"
          rel="noopener"
          >https://policies.google.com/privacy?hl=hu</a
        >
        <br />
        Az adatok felhasználásával és védelmével kapcsolatos információk
        részletesen a fenti hivatkozásokon érhetők el.
      </p>
      <p>
        <strong>Adatvédelem részletesen:</strong><br />
        <a
          href="https://static.googleusercontent.com/media/www.google.com/en//intl/hu/policies/privacy/google_privacy_policy_hu.pdf"
          target="_blank"
          rel="noopener"
          >https://static.googleusercontent.com/media/www.google.com/en//intl/hu/policies/privacy/google_privacy_policy_hu.pdf</a
        >
      </p>

      <h2>Fontos adatkezelési információk</h2>
      <p>
        Az adatkezelés elsődleges célja, a szolgáltató weboldalának látogatóinak
        védelme.
      </p>
      <p>
        Az adatkezelés jogalapja az érintett személy hozzájárulása. Az
        adatkezelés időtartama és az adatok törlése. Az adatkezelés időtartama
        mindig a konkrét felhasználói célfüggvénye, de az adatokat
        haladéktalanul törölni kell, ha az eredetileg kitűzött cél már
        megvalósult. Az adatkezeléshez történő hozzájárulását az érintett
        személy bármikor visszavonhatja a kapcsolattartási e-mail címre küldött
        levélben. Amennyiben a törlésnek jogszabályi akadálya nincs, ez esetben
        adatai törlésre kerülnek. Az adatok megismerésére jogosultak az
        adatkezelő és alkalmazottai.
      </p>
      <p>
        <strong
          >Az érintett személy kérelmezheti az adatkezelőtől a rá vonatkozó
          személyes adatokhoz való hozzáférést, azok helyesbítését, törlését
          vagy kezelésének korlátozását, és tiltakozhat az ilyen személyes
          adatok kezelése ellen, valamint az érintett adathordozhatósághoz való
          jogáról.</strong
        >
      </p>
      <p>
        Az érintett személy bármely időpontban visszavonhatja az adatkezelési
        hozzájárulását, de ez nem érinti a visszavonás előtt a hozzájárulás
        alapján végrehajtott adatkezelés jogszerűségét. Az érintett személy
        élhet a felügyeleti hatósághoz címzett panasz benyújtásának jogával. Az
        érintett személy jogosult arra, hogy kérésére az adatkezelő indokolatlan
        késedelem nélkül helyesbítse illetve kiegészítse a rá vonatkozó
        pontatlan személyes adatokat. Az érintett személy jogosult arra, hogy
        kérésére az adatkezelő indokolatlan késedelem nélkül törölje a rá
        vonatkozó pontatlan személyes adatokat, az adatkezelő pedig köteles
        arra, hogy az érintettre vonatkozó személyes adatokat indokolatlan
        késedelem nélkül törölje, amennyiben az adatkezelésnek nincs más
        jogalapja. A személyes adatok módosítása vagy törlése kezdeményezhető
        e-mailben, telefonon vagy levélben a fentebb megadott elérhetőségi
        lehetőségeken.
      </p>

      <h2>Számlakiállítás</h2>
      <p>
        Az adatkezelés célja számla, elektronikus vagy papír alapú számla
        kiállítása és küldése e-mail mellékletként. Az adatkezelés jogalapja
        jogszabályon alapuló kötelező adatkezelés. Az adatkezelésben érintettek
        köre a szolgáltató vevőpartnerei.
      </p>
      <p>
        <strong><u>Az adatkezelés időtartama</u></strong
        >: Az adatkezelés jogszabályi előírás, illetve a hozzájárulás
        visszavonásáig történik. Az adatkezeléshez történő hozzájárulását Ön
        bármikor visszavonhatja a kapcsolattartási e-mail címre küldött
        levélben. Az adatok törlése az adatkezeléshez történő hozzájárulás
        visszavonásakor történik meg. Ön bármikor visszavonhatja az
        adatkezeléshez történő hozzájárulását a kapcsolattartási e-mail címre
        küldött levélben. A számlázási adatok törlése jogszabályi előírás
        szerint történhet meg. Az adatok megismerésére jogosultak az adatkezelő
        és alkalmazottai. Az adatok tárolási módja: elektronikus. A számlaadatok
        módosítása vagy törlése kezdeményezhető e-mailben, telefonon vagy
        levélben a fentebb megadott elérhetőségi lehetőségeken.
      </p>

      <h3><u>Kezelt adatok köre</u></h3>
      <h4>Az adatkezelési adatok konkrét célja</h4>
      <ul class="def-list">
        <li><u>Név:</u> Azonosítás, kapcsolattartás, számlázás.</li>
        <li><u>Cégnév:</u> Azonosítás, kapcsolattartás, számlázás.</li>
        <li><u>Cím:</u> Azonosítás, kapcsolattartás, számlázás.</li>
        <li><u>E-mail:</u> Azonosítás, kapcsolattartás.</li>
        <li><u>Telefon:</u> Azonosítás, kapcsolattartás.</li>
        <li><u>Adószám / adóazonosító:</u> A vevő azonosítása.</li>
        <li><u>Számlaadatok:</u> A számla azonosítása.</li>
        <li>
          <u>Számlakiállítás időpontja:</u> Technikai információs művelet.
        </li>
      </ul>
      <p>
        Az érintett személy tiltakozhat a személyes adatai kezelése ellen, e
        tekintetben a fentebb részletezett adatkezelési információk és ezen
        tájékoztató, valamint a tájékoztatóban ismertetett jogszabályok szerinti
        eljáráshoz jogosult.
      </p>

      <h2>Sütik (cookie-k)</h2>
      <p>
        A sütik (cookie-k) olyan kisméretű adatfájlok (továbbiakban: sütik),
        amelyek a weboldalon keresztül a weboldal használatával kerülnek az Ön
        számítógépére úgy, hogy azokat az Ön internetes böngészője menti le és
        tárolja el. A leggyakrabban használt internetes böngészők (Chrome,
        Firefox, stb.) többsége alapbeállításként elfogadja és engedélyezi a
        sütik letöltését és használatát, az viszont már Öntől függ, hogy a
        böngésző beállításainak módosításával ezeket visszautasítja vagy
        letiltja, illetve Ön a már a számítógépen lévő eltárolt sütiket is tudja
        törölni.
      </p>
      <p>
        Vannak olyan sütik, amelyek nem igénylik az Ön előzetes hozzájárulását.
        Ezekről weblapunk az Ön első látogatásának megkezdésekor ad rövid
        tájékoztatást, ilyenek például a hitelesítési, multimédia-lejátszó,
        terheléskiegyenlítő, a felhasználói felület testreszabását segítő
        munkamenet-sütik, valamint a felhasználó-központú biztonsági sütik.
      </p>
      <p>
        <strong>Cookie Típusa:</strong> Google Analytics programot a fent
        megnevezett weboldal alkalmaz.
      </p>
      <p>
        Funkciója: ez a Google, inc. (1600 Amphitheatre Parkway, Mountain View,
        CA 94043, USA) által használt cookie azt rögzíti, hogy a felhasználók
        hogyan használják a honlapot. Az így rögzített információk alapján
        kimutatások készíthetőek, amelyek segítenek továbbfejleszteni a
        weboldalt.
      </p>
      <p>A cookie többek között az alábbi információt rögzíti anonim módon:</p>
      <ol class="roman-list">
        <li>a weboldalt látogatók száma,</li>
        <li>
          a honlapot látogatók mely honlapról érkeztek a weboldalra, továbbá
        </li>
        <li>a honlapot látogatók a weboldal mely oldalait látogatták meg.</li>
      </ol>
      <p>Érvényesség (törlés időpontja vagy határideje): 2 év</p>

      <h2>Adatfeldolgozók Tárhelyszolgáltató:</h2>
      <table>
        <tbody>
          <tr>
            <th>Név / cégnév</th>
            <td>Deal-Inform Kft.</td>
          </tr>
          <tr>
            <th>Székhely:</th>
            <td>4030. Debrecen, Kosárfonó utca 28.</td>
          </tr>
          <tr>
            <th>Levelezési cím:</th>
            <td>4030. Debrecen, Kosárfonó utca 28.</td>
          </tr>
          <tr>
            <th>E-mail:</th>
            <td>kapcsolat@dealinform.hu</td>
          </tr>
        </tbody>
      </table>
      <p>
        Az Ön által megadott adatokat a tárhelyszolgáltató által üzemeltetett
        szerver tárolja. Az adatokhoz csak munkatársaink, illetve a szervert
        üzemeltető munkatársak férhetnek hozzá, de mindannyian felelősséggel
        tartoznak az adatok biztonságos kezeléséért. A tevékenység megnevezése:
        tárhelyszolgáltatás, szerverszolgáltatás. Az adatkezelés célja: a
        weboldal működésének biztosítása. A kezelt adatok: az érintett által
        megadott személyes adatok. Az adatkezelés időtartama és az adatok
        törlésének határideje.
      </p>
      <p>
        Az adatkezelés a weboldal működésének végéig, illetve a weboldal
        működtetője és a tárhelyszolgáltató közötti szerződéses megállapodás
        szerint. Az érintett személy szükség esetén a tárhelyszolgáltatót
        megkeresve is kérheti adatai törlését. Az adatkezelés jogalapja az
        érintett személy hozzájárulása, illetve jogszabályon alapuló
        adatkezelés.
      </p>
      <p>
        Az Ön adatait csak jogszabályban meghatározott keretek között
        továbbíthatjuk, adatfeldolgozóink esetében pedig szerződéses feltételek
        kikötésével biztosítjuk, hogy ne használhassák az Ön hozzájárulásával
        ellentétes célokra az Ön személyes adatait. További információ a 2.
        pontban található.
      </p>
      <p>Társaságunk külföldre nem továbbít adatokat.</p>
      <p>
        A bíróság, az ügyészség és más hatóságok (pl. rendőrség, adóhivatal,
        Nemzeti Adatvédelmi és Információszabadság Hatóság) tájékoztatás adása,
        adatok közlése vagy iratok rendelkezésre bocsátása miatt megkereshetik
        Társaságunkat. Ezekben az esetekben adatszolgáltatási kötelezettségünket
        teljesítenünk kell, de csak a megkeresés céljának megvalósításához
        elengedhetetlenül szükséges mértékben.
      </p>
      <p>
        Társaságunk adatkezelésében és/vagy adatfeldolgozásában részt vevő
        közreműködői és munkavállalói előre meghatározott mértékben –
        titoktartási kötelezettség terhe mellett – jogosultak az Ön személyes
        adatait megismerni.
      </p>
      <p>
        Az Ön személyes adatait megfelelő technikai és egyéb intézkedésekkel
        védjük, valamint biztosítjuk az adatok biztonságát, rendelkezésre
        állását, továbbá óvjuk azokat a jogosulatlan hozzáféréstől,
        megváltoztatástól, sérülésektől illetve nyilvánosságra hozataltól és
        bármilyen egyéb jogosulatlan felhasználástól.
      </p>
      <p>
        Szervezeti intézkedések keretében épületeinkben ellenőrizzük a fizikai
        hozzáférést, munkavállalóinkat folyamatosan oktatjuk és a papír alapú
        dokumentumokat megfelelő védelemmel elzárva tartjuk. A technikai
        intézkedések keretében titkosítást, jelszóvédelmet és vírusirtó
        szoftvereket használunk. Felhívjuk azonban a figyelmét arra, hogy az
        interneten keresztüli adattovábbítás nem tekinthető teljes körűen
        biztonságos adattovábbításnak.
      </p>
      <p>
        Társaságunk mindent megtesz annak érdekében, hogy a folyamatokat minél
        biztonságosabbá tegyük, a weblapunkon keresztül történő
        adattovábbításért azonban nem tudunk teljes felelősséget vállalni, ám a
        Társaságunkhoz beérkezett adatok tekintetében szigorú előírásokat
        tartunk be az Ön adatainak biztonsága és a jogellenes hozzáférés
        megakadályozása érdekében.
      </p>

      <h2>Kezelt adatok</h2>
      <h4>Az adatkezelés időtartama</h4>
      <p>
        Az adott cookie adattárolási időtartama, bővebb információ elérhető itt:
      </p>
      <p>
        Google általános cookie tájékoztató:<br />
        <a
          href="https://www.google.com/policies/technologies/types/"
          target="_blank"
          rel="noopener"
          >https://www.google.com/policies/technologies/types/</a
        >
      </p>
      <p>
        Google Analitycs tájékoztató:<br />
        <a
          href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=hu"
          target="_blank"
          rel="noopener"
          >https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=hu</a
        >
      </p>

      <h2>Melyek az Ön jogai és jogorvoslati lehetőségei?</h2>
      <p><u>Ön az adatkezelésről</u></p>
      <ul class="definition-list">
        <li>tájékoztatást kérhet,</li>
        <li>
          kérheti az általunk kezelt személyes adataik helyesbítését,
          módosítását, kiegészítését,
        </li>
        <li>
          tiltakozhat az adatkezelés ellen és kérheti adatai törlését valamint
          zárolását (a kötelező adatkezelés kivételével),
        </li>
        <li>bíróság előtt jogorvoslattal élhet,</li>
        <li>
          a felügyelő hatóságnál panaszt tehet, illetve eljárást kezdeményezhet
          (<a
            href="https://naih.hu/panaszuegyintezes-rendje.html"
            target="_blank"
            rel="noopener"
            >https://naih.hu/panaszuegyintezes-rendje.html</a
          >).
        </li>
      </ul>

      <h2>
        Felügyelő Hatóság: Nemzeti Adatvédelmi és Információszabadság Hatóság
      </h2>
      <ul>
        <li>Székhely: 1055 Budapest, Falk Miksa utca 9-11.</li>
        <li>Levelezési cím: 1530 Budapest, Pf.: 9.</li>
        <li>Telefon: +36 (1) 391-1400</li>
        <li>Fax: +36 (1) 391-1410</li>
        <li>E-mail: ugyfelszolgalat@naih.hu</li>
        <li>
          Honlap:
          <a href="https://naih.hu/" target="_blank" rel="noopener"
            >https://naih.hu/</a
          >
        </li>
      </ul>

      <h2>BUDAPESTI BÉKÉLTETŐ TESTÜLET</h2>
      <ul>
        <li>Cím: 1016 Budapest, Krisztina krt. 99. I. em. 111.</li>
        <li>Postacím: 1253 Budapest, Pf.:10.</li>
        <li>Telefonszáma: +36-1-488-21-31</li>
        <li>Fax száma: +36-1-488-21-86</li>
        <li>Elnök: Dr. Inzelt Éva Veronika</li>
        <li>
          E-mail cím:
          <a href="mailto:bekelteto.testulet@bkik.hu"
            >bekelteto.testulet@bkik.hu</a
          >
        </li>
      </ul>

      <p>
        <strong>Az Ön kérelmére tájékoztatást adunk</strong> az Ön általunk
        kezelt, illetve az általunk – vagy a megbízott adatfeldolgozónk által –
        feldolgozott
      </p>
      <ul class="definition-list">
        <li>adatairól,</li>
        <li>azok forrásáról,</li>
        <li>az adatkezelés céljáról és jogalapjáról,</li>
        <li>
          időtartamáról, ha pedig ez nem lehetséges, ezen időtartam
          meghatározásának szempontjairól,
        </li>
        <li>
          az adatfeldolgozóink nevéről, címéről és az adatkezeléssel összefüggő
          tevékenységükről,
        </li>
        <li>
          adatvédelmi incidensek körülményeiről, hatásairól és az elhárításukra
          valamint megelőzésükre tett intézkedéseinkről, továbbá
        </li>
        <li>
          az Ön személyes adatainak továbbítása esetén az adattovábbítás
          jogalapjáról és címzettjéről.
        </li>
      </ul>
      <p>
        A kérelem benyújtásától számított legrövidebb idő alatt, 10 napon belül
        (legfeljebb azonban 1 hónapon belül) adjuk meg tájékoztatásunkat. A
        tájékoztatás ingyenes kivéve akkor, ha Ön a folyó évben azonos adatkörre
        vonatkozóan tájékoztatási kérelmet már nyújtott be hozzánk. Az Ön által
        már megfizetett költségtérítést visszatérítjük abban az esetben, ha az
        adatokat jogellenesen kezeltük vagy a tájékoztatás kérése helyesbítéshez
        vezetett. A tájékoztatást csak törvényben foglalt esetekben tagadhatjuk
        meg jogszabályi hely megjelölésével, valamint a bírósági jogorvoslat
        illetve a Hatósághoz fordulás lehetőségéről tájékoztatással.
      </p>
      <p>
        Társaságunk a személyes adatok helyesbítésről, zárolásról, megjelölésről
        és törlésről Önt, továbbá mindazokat értesíti, akiknek korábban az
        adatot adatkezelés céljára továbbította, kivéve akkor, ha az értesítés
        elmaradása az Ön jogos érdekét nem sérti.
      </p>
      <p>
        Amennyiben az Ön helyesbítés, zárolás vagy törlés iránti kérelmét nem
        teljesítjük, a kérelem kézhezvételét követő 10 napon belül (legfeljebb
        azonban 1 hónapon belül) írásban vagy – az Ön hozzájárulásával –
        elektronikus úton közöljünk elutasításunk indokait és tájékoztatjuk Önt
        a bírósági jogorvoslat, továbbá a Hatósághoz fordulás lehetőségéről.
      </p>
      <p>
        Amennyiben Ön tiltakozik a személyes adatai kezelése ellen, a
        tiltakozást a kérelem benyújtásától számított legrövidebb időn belül, 10
        napon belül (legfeljebb azonban 1 hónapon belül) megvizsgáljuk és a
        döntésünkről Önt írásban tájékoztatjuk. Amennyiben úgy döntöttünk, hogy
        az Ön tiltakozása megalapozott, abban az esetben az adatkezelést -
        beleértve a további adatfelvételt és adattovábbítást is - megszüntetjük
        és az adatokat zároljuk, valamint a tiltakozásról, továbbá az annak
        alapján tett intézkedésekről értesítjük mindazokat.
      </p>

      <h3><u>Az adatkezelés alapjául szolgáló jogszabályok</u></h3>
      <p>
        AZ EURÓPAI PARLAMENT ÉS A TANÁCS (EU) 2016/679 RENDELETE (2016. április
        27.) a természetes személyeknek a személyes adatok kezelése tekintetében
        történő védelméről és az ilyen adatok szabad áramlásáról, valamint a
        95/46/EK rendelet hatályon kívül helyezéséről (általános adatvédelmi
        rendelet). - 2011. évi CXII. törvény az információs önrendelkezési
        jogról és az információszabadságról. - 2001. évi CVIII. törvény az
        elektronikus kereskedelmi szolgáltatások, valamint az információs
        társadalommal összefüggő szolgáltatások egyes kérdéseiről. - 2003. évi
        C. törvény az elektronikus hírközlésről. - 2007. évi CXXVII. törvény (a
        továbbiakban: ÁFA tv.) és különösen annak 169. § alapján (a nyugtaadási
        kötelezettség, valamint a számla adattartalma miatt).
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppAdatkezelesi",
};
</script>

<style scoped>
.bg-adatkezelesi {
  background-color: #3e5c76;
}
.pl-45 {
  padding-left: 45px;
}
.doc-width {
  min-width: 595.3pt;
  max-width: 595.3pt;
  min-height: 841.9pt;
}
h1 {
  font-size: 24pt;
  font-weight: bold;
  text-align: center;
  margin: 1em 0 0.5em;
}
.subtitle {
  text-align: center;
  font-weight: bold;
  margin-bottom: 2em;
}
h2 {
  font-size: 14pt;
  font-weight: bold;
  text-decoration: underline;
  margin: 1.5em 0 0.75em;
}
h3 {
  font-size: 12pt;
  font-weight: bold;
  margin: 1.25em 0 0.5em;
}
h4 {
  font-size: 11pt;
  font-weight: bold;
  margin: 1em 0 0.5em;
}
p {
  margin: 0.5em 0;
  line-height: 1.5;
  text-align: justify;
}
ol,
ul {
  margin: 0.5em 0 0.5em 2em;
  line-height: 1.5;
}
ol[type="a"] {
  list-style-type: lower-alpha;
}
ol li,
ul li {
  margin: 0.25em 0;
}
ul.def-list {
  list-style-type: none;
  margin-left: 0;
}
ul.def-list li {
  margin: 0.5em 0;
  text-align: justify;
}
table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.75em 0;
}
th,
td {
  border: 1px solid #000;
  padding: 8px 12px;
  text-align: left;
  vertical-align: top;
  font-weight: normal;
}
th {
  width: 40%;
}
a {
  color: #1d2d44;
  text-decoration: underline;
  word-break: break-all;
}

/* A lista alapbeállításai */
ol.custom-list {
  list-style: none; /* Kikapcsoljuk az alapértelmezett a. formátumot */
  counter-reset: item; /* Elindítjuk a saját számlálónkat 'item' néven */
  padding-left: 2em; /* Helyet hagyunk a bal oldalon a betűknek */
}

/* A lista elemei */
ol.custom-list li {
  counter-increment: item; /* Minden egyes listaeleménél növeljük a számlálót */
  position: relative;
  margin-bottom: 8px; /* Egy kis távolság a sorok között a jobb olvashatóságért */
}

/* A betűk és a zárójel formázása a szöveg előtt */
ol.custom-list li::before {
  content: counter(item, lower-latin) ") "; /* Kisbetűs latin számláló + zárójel */
  position: absolute;
  left: -1.5em; /* Visszatoljuk a betűt a szöveg elé a margóra */
  width: 1.2em; /* Fix szélesség, hogy a zárójelek egymás alatt legyenek */
  text-align: right; /* Jobbra igazítjuk, hogy szép legyen a felsorolás */
}

.number-list {
  list-style-type: decimal; /* Ez visszaállítja a sima 1. 2. 3. számozást */
  padding-left: 40px; /* Kell a hely a számoknak */
}

ul.definition-list {
  list-style-type: none; /* Eltüntetjük a pöttyöket */
  padding-left: 1.5em; /* Helyet csinálunk a vonalnak */
  margin-left: 0;
}

ul.definition-list li {
  position: relative;
  margin-bottom: 10px;
  text-align: justify;
}

ul.definition-list li::before {
  content: "-"; /* Ez teszi oda a kötőjelet */
  position: absolute;
  left: -1em; /* Kitoljuk a szöveg elé balra */
  font-weight: bold; /* Hogy jobban látsszon */
}

/* Római számok zárójelben: (i), (ii), (iii) */
ol.roman-list {
  list-style: none; /* Kikapcsoljuk az alapértelmezett számozást */
  counter-reset: roman-counter;
  padding-left: 3em; /* A (iii) kicsit szélesebb, kell a hely */
}

ol.roman-list li {
  counter-increment: roman-counter;
  position: relative;
  margin-bottom: 8px;
}

ol.roman-list li::before {
  /* lower-roman = kisbetűs római számok, idézőjelek között a két zárójel */
  content: "(" counter(roman-counter, lower-roman) ") ";
  position: absolute;
  left: -2.5em; /* Helyre igazítjuk a szöveg előtt */
  width: 2em;
  text-align: right;
}
</style>
